import "./background.css";
import React from 'react'
import Nav from "./navbar";

export const Background = ({hSignOut, changePage, setSidebarSections, activePlant}) => {
    const Signout = () => {
        hSignOut();
    };
    return (
        <div className="box" >
            <div className="group">
                <div className="overlap-group">
                    <Nav
                      SignOut={Signout}
                      changePage={changePage}
                      setSidebarSections={setSidebarSections}
                      activePlant={activePlant}
                    />
                </div> 
            </div>
        </div>
    );
};
